import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-change-email-message',
    templateUrl: './change-email-message.component.html',
    styleUrls: ['./change-email-message.component.css']
})
export class ChangeEmailMessageComponent implements OnInit, OnDestroy {

        //Properties
        dialogBox: MatDialogRef<ChangeEmailMessageComponent>;
        confirmEvent: EventEmitter<boolean> = new EventEmitter<boolean> ();

        //Class Functions
        constructor() { }

        //Event Functions
        ngOnInit() {

        }

        ngOnDestroy () {
            //POST: Emits a non-confirmation event
            this.confirmEvent.emit(false);
        }

        //Methods
        confirm (confirmation: boolean) {
            //PRE: confirmation should reflect if the user agrees or not
            //POST: sends a confirmation event to a receiving component
            this.confirmEvent.emit(confirmation);
            this.dialogBox.close();
        }
}
